import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalCancelScheduledPublish: ExperimentalMutations['experimentalCancelScheduledPublish'] =
	(_, { contentId }, { network: { cfetch } }) => {
		if (!contentId) {
			throw new Error('contentId is missing');
		}

		return cfetch(`/wiki/rest/api/content/${contentId}/schedule/publish`, {
			method: 'DELETE',
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
		}).then(
			(response) => ({
				success: response.ok,
			}),
			// TODO: You're better than this.
			() => ({
				success: false,
			}),
		);
	};
